export default "__VITE_ASSET__Ds7t0FCg__"